export default {
  login: {
    title: '賬戶密碼登錄',
    scanTitle: 'APP掃碼登錄',
    codeTitle: '手機驗證登錄',
    logIn: '登錄',
    username: '請輸入賬號',
    password: '請輸入密碼',
    rule: '用戶名或手機號',
    version: '版本',
    upper: '大寫已鎖定',
    scanTip: 'APP掃碼登錄',
    accountTip: '請輸入賬號',
    passwordTip: '請輸入密碼',
    codeTip: '請輸入驗證碼',
    changeCode: '點擊切換驗證碼',
    mobile: '請輸入手機號',
    rightMobile: '請輸入正確的手機號',
    smsCode: '請輸入驗證碼',
    getCode: '獲取驗證碼',
    reSend: '重新發送',
    company: '請輸入公司名',
    contacts: '請輸入聯系人'
  },
  Service: {
    // 常見問題
    faqTitle: '常見問題',
    // 分類標題（與 zh/en 對齊，避免繁體回退顯示英文 key）
    allTitle: '全部',
    videoTitle: '視頻教程',
    downloadTitle: '資源下載',
    newsTitle: '更新日誌',
    mediaTitle: '新媒體視頻',
  },
  guide: {
    entryTip: '新手引導',
    next: '下一步',
    prev: '上一步',
    done: '完成',
    goNext: '去下一步',
    stepPersonalTitle: '第一步：進入個人中心',
    stepPersonalDesc: '點擊右上角頭像進入「個人中心」，在這裡管理您的訂單、許可證和發票。',
    stepOrderTitle: '第二步：下載已購軟件',
    stepOrderDesc: '在「訂單管理」中找到對應訂單，點擊「下載」即可獲取已購軟件的安裝包與下載鏈接。',
    stepLicenseTitle: '第三步：創建許可證',
    stepLicenseDesc: '在「許可證申請」中點擊「創建許可證」，按提示填寫機器碼即可生成許可。',
    stepScanTitle: '手機掃碼申請許可流程',
    stepScanDesc: '可使用手機掃描下圖所示流程完成許可證申請。'
  },
}